import {
  AiChatModule,
  AiQueryExtensionModule,
  AssignedAnswerModule,
  ClassifyQuestionModule,
  ContentProcessModule,
  ContentExtractModule,
  KnowledgeConcat,
  KnowledgeBaseModule,
  DelayModule,
  FlowModuleTemplateType,
  GlobalVariableModule,
  HTTPModule,
  ModuleTemplateType,
  ModuleTemplateTypeEnum,
  PluginInputModule,
  TFJudgeModule,
  ToolModule,
  UserChatInputModule,
  PluginOutputModule,
  PluginModule,
  ChatHistoryModule,
  OutputTextModule,
  OutputCardModule,
  OutputFileModule,
  GetChatAttributesModule,
  SetChatAttributesModule,
} from "@packages/flow-core/module";

export const moduleTemplatesList: ModuleTemplateType[] = [
  {
    type: ModuleTemplateTypeEnum.getContent,
    label: "获取内容",
    list: [],
  },
  {
    type: ModuleTemplateTypeEnum.systemInput,
    label: "系统输入",
    list: [],
  },
  {
    type: ModuleTemplateTypeEnum.output,
    label: "输出",
    list: [],
  },
  {
    type: ModuleTemplateTypeEnum.functionCall,
    label: "功能调用",
    list: [],
  },
  {
    type: ModuleTemplateTypeEnum.tools,
    label: "工具",
    list: [],
  },
  {
    type: ModuleTemplateTypeEnum.externalCall,
    label: "外部调用",
    list: [],
  },
  {
    type: ModuleTemplateTypeEnum.flowControl,
    label: "流程控制",
    list: [],
  },
  {
    type: ModuleTemplateTypeEnum.logicDeal,
    label: "逻辑处理",
    list: [],
  },
  // {
  //   type: ModuleTemplateTypeEnum.personalPlugin,
  //   label: 'core.module.template.My plugin module',
  //   list: [],
  // },
  {
    type: ModuleTemplateTypeEnum.other,
    label: "其他",
    list: [],
  },
  // AI机器人嵌入
  {
    type: ModuleTemplateTypeEnum.appCall,
    label: "AI机器人嵌入",
    list: [],
  },
  // 子流程调用
  {
    type: ModuleTemplateTypeEnum.pluginCall,
    label: "子流程调用",
    list: [],
  },
  // 企业微信
  {
    type: ModuleTemplateTypeEnum.enterpriseWeChat,
    label: "企业微信",
    list: [],
  },
  {
    type: ModuleTemplateTypeEnum.damselfish,
    label: "12Times",
    list: [],
  },
];

export const moduleTemplatesFlat: FlowModuleTemplateType[] = [
  GlobalVariableModule,
  UserChatInputModule,
  AssignedAnswerModule,
  AiChatModule,
  TFJudgeModule,
  DelayModule,
  ClassifyQuestionModule,
  KnowledgeBaseModule,
  ContentExtractModule,
  ContentProcessModule,
  HTTPModule,
  AiQueryExtensionModule,
  KnowledgeConcat,
  ClassifyQuestionModule,
  ToolModule,
  PluginInputModule,
  PluginOutputModule,
  PluginModule,
  ChatHistoryModule,
  OutputTextModule,
  OutputCardModule,
  OutputFileModule,
  GetChatAttributesModule,
  SetChatAttributesModule,
];
